import React, { useEffect, useState } from 'react'


const Admin = () => {
  const [courses, setCourses] = useState([])

  const [title, setTitle] = useState("")
  const [desc, setDesc] = useState("")
  const [price, setPrice] = useState("")
  const [video, setVideo] = useState("")

  useEffect(() => {
    const data = localStorage.getItem("courses")
    if (data) {
      setCourses(JSON.parse(data))
    }
  }, [])

  const addCourse = (e) => {
    e.preventDefault()

    const newCourse = {
      title,
      description: desc,
      price,
      video
    }

    const updated = [...courses, newCourse]

    setCourses(updated)
    localStorage.setItem("courses", JSON.stringify(updated))

    
    setTitle("")
    setDesc("")
    setPrice("")
    setVideo("")
  }
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div>
       <header>
      <a href="/"><div className="logo">
        <img src="/logoo.svg" alt="logo" />
        IlyosDev
      </div></a>

      
      <nav className={`nav-links ${menuOpen ? "active" : ""}`}>
        <a href="/">About</a>
        <a href="/videos">Course Detail</a>
        <a href="/learn">Learn</a>
         <a href="/dashboard">Dashboard</a>
        <a href="/enroll"><button>Kursga yozilish</button></a>

      </nav>

      
      <div
        className={`burger ${menuOpen ? "open" : ""}`}
        onClick={() => setMenuOpen(!menuOpen)}
      >
        <span></span>
        <span></span>
        <span></span>
      </div>
    </header>
<div className="admin-container">
  

  <h1 className="admin-title">Admin Panel</h1>

  <form className="admin-form" onSubmit={addCourse}>
    <input placeholder="Title" value={title} onChange={(e)=>setTitle(e.target.value)}required />
    <input placeholder="Description" value={desc} onChange={(e)=>setDesc(e.target.value)}required />
    <input placeholder="Price" value={price} onChange={(e)=>setPrice(e.target.value)} required/>
    <input placeholder="YouTube embed link" value={video} onChange={(e)=>setVideo(e.target.value)} required/>

    <button type="submit">Add Course</button>
  </form>

  <div className="course-list">
    {courses.map((c, i) => (
      <div className="course-card" key={i}>
        <h2>{c.title}</h2>
        <p>{c.description}</p>
        <p>{c.price} SUM</p>

        <iframe src={c.video} title="video"></iframe>
      </div>
    ))}
  </div>
</div>
    </div>
  )
}

export default Admin